/* global common */
import { sendAmplitudeEvent, sendRequest } from '@html/_common/utils';

export default function StickyMenu({ selector = '', onClose, onOpen }) {
  this.common = {};
  if (typeof sendRequest !== 'undefined') {
    this.common = {
      sendRequest,
      sendAmplitudeEvent,
    };
  } else {
    this.common = common;
  }

  const SELECTOR_MENU = `${selector} .js-ao-sticky-menu`;
  const SELECTOR_LIST = `${selector} .js-ao-sticky-menu__sheet-list`;
  const SELECTOR_STICKY_SHEET = `${selector}.js-ao-sticky-menu__sheet`;
  const SELECTOR_CLICKABLE_ELEMENT = ` ${selector}.js-ao-navigation-menu__clickable`;
  const SELECTOR_CONTAINER = `${selector} .js-ao-sticky-menu__sheet-container`;
  const SELECTOR_CLOSE_SHEET = `${selector} .js-ao-sticky-menu__sheet-close`;
  const ACTIVE_CLASS = 'ao-sticky-menu__sheet-list--visible';
  const HIDDEN_CLASS = 'ao-sticky-menu__sheet-container--hidden';
  const CHILDREN_ACTIVE_CLASS = 'ao-sticky-menu__sheet-children-item--visible';
  const SELECTOR_BACK_BUTTON = `${selector} .js-ao-sticky-menu__sheet-back`;
  const SELECTOR_PARENT_ITEM = `${selector} .js-ao-sticky-menu__sheet-list-item`;
  const SELECTOR_OUTSIDE = `${selector} .js-ao-sticky-menu__sheet-outside`;

  // Component navigation selectors
  const SELECTOR_COMPONENT = `${selector} .js-ao-sticky-menu__component`;
  const SELECTOR_NAVIGATION_CONTAINER = `${selector} .js-ao-sticky-menu__component-navigation`;
  const SELECTOR_NEXT_BUTTON = `${selector} .js-ao-sticky-menu__navigation-button--next`;
  const SELECTOR_FINISH_BUTTON = `${selector} .js-ao-sticky-menu__navigation-button--finish`;
  const SELECTOR_BACK_BUTTON_NAV = `${selector} .js-ao-sticky-menu__navigation-button--back`;

  let activeParentMenu;
  let scrollOffset;
  let activeComponentIndex = 0;
  const $body = document.querySelector('body');

  const blockBodyScrolling = () => {
    scrollOffset = window.pageYOffset;

    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `${-scrollOffset}px`;
    $body.style.touchAction = 'none';
    $body.style.width = '100%';
  };

  const enableBodyScrolling = () => {
    $body.style.removeProperty('position');
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('top');
    $body.style.removeProperty('touch-action');
    $body.style.removeProperty('width');

    window.scrollTo({ top: scrollOffset, behavior: 'instant' });
  };

  const updateNavigationButtons = () => {
    const totalComponents = $(SELECTOR_COMPONENT).length;

    // Show/hide back button (both bottom and sheet back button)
    if (activeComponentIndex === 0) {
      $(SELECTOR_BACK_BUTTON_NAV).addClass('hid');
      $(SELECTOR_BACK_BUTTON).addClass('hid');
    } else {
      $(SELECTOR_BACK_BUTTON_NAV).removeClass('hid');
      $(SELECTOR_BACK_BUTTON).removeClass('hid');
    }

    // Show/hide Next and Finish buttons based on component position
    if (activeComponentIndex === totalComponents - 1) {
      // Last component - hide Next button, show Finish button
      $(SELECTOR_NEXT_BUTTON).addClass('hid');
      $(SELECTOR_FINISH_BUTTON).removeClass('hid');
    } else {
      // Not last component - show Next button, hide Finish button
      $(SELECTOR_NEXT_BUTTON).removeClass('hid');
      $(SELECTOR_FINISH_BUTTON).addClass('hid');
    }
  };

  const resetComponentNavigation = () => {
    activeComponentIndex = 0;
    $(SELECTOR_COMPONENT).removeClass('ao-sticky-menu__component--active');
    $(SELECTOR_COMPONENT).first().addClass('ao-sticky-menu__component--active');
    updateNavigationButtons();
  };

  const openMenu = (menuId) => {
    activeParentMenu = menuId;
    $(SELECTOR_STICKY_SHEET).removeClass('hid');
    setTimeout(() => $(SELECTOR_CONTAINER).removeClass(HIDDEN_CLASS), 50);
    blockBodyScrolling();
    $(`${SELECTOR_LIST}-${menuId}`).addClass('ao-sticky-menu__sheet-list--visible');
    $('.live-chat').addClass('hid');
    $('.js-ao-tour-sticky-bar').addClass('hid');
    $('#messages').addClass('hid');
    onOpen?.();
  };

  const closeMenu = () => {
    enableBodyScrolling();
    const parentMenuSelector = `.js-ao-sticky-menu__list-item[data-seo-name="${activeParentMenu}"]`;
    $(SELECTOR_LIST).removeClass('ao-sticky-menu__sheet-list--visible');
    $(SELECTOR_CONTAINER).addClass(HIDDEN_CLASS);
    setTimeout(() => $(SELECTOR_STICKY_SHEET).addClass('hid'), 250);
    $(`.${CHILDREN_ACTIVE_CLASS}`).removeClass(CHILDREN_ACTIVE_CLASS);
    $(SELECTOR_BACK_BUTTON).addClass('hid');
    $(parentMenuSelector).removeClass('ao-sticky-menu__list-item--active');
    $('.live-chat').removeClass('hid');
    $('.js-ao-tour-sticky-bar').removeClass('hid');
    $('#messages').removeClass('hid');
    onClose?.();

    // Reset component navigation when closing
    setTimeout(() => resetComponentNavigation(), 350);
  };

  const switchToComponent = (componentIndex) => {
    // Hide all components
    $(SELECTOR_COMPONENT).removeClass('ao-sticky-menu__component--active');

    // Show selected component
    $(`${SELECTOR_COMPONENT}[data-component-index="${componentIndex}"]`).addClass('ao-sticky-menu__component--active');

    activeComponentIndex = componentIndex;
    updateNavigationButtons();
  };

  const handleNextButtonClick = () => {
    const totalComponents = $(SELECTOR_COMPONENT).length;

    if (activeComponentIndex < totalComponents - 1) {
      // Go to next component
      switchToComponent(activeComponentIndex + 1);

      // Send amplitude event for navigation
      const eventName = $(SELECTOR_MENU).data('event-name');
      if (eventName) {
        this.common.sendAmplitudeEvent({
          ampEventName: eventName,
          navigation_menu_option: 'Next',
          navigation_menu_section: 'Component Navigation',
        });
      }
    } else {
      // Finish - close the menu
      closeMenu();
    }
  };

  const handleNavigationBackButtonClick = () => {
    if (activeComponentIndex > 0) {
      // Go to previous component
      switchToComponent(activeComponentIndex - 1);

      // Send amplitude event for navigation
      const eventName = $(SELECTOR_MENU).data('event-name');
      if (eventName) {
        this.common.sendAmplitudeEvent({
          ampEventName: eventName,
          navigation_menu_option: 'Back',
          navigation_menu_section: 'Component Navigation',
        });
      }
    }
  };

  const handleSheetBackButtonClick = () => {
    // Check if we're in component navigation mode
    const $navigationContainer = $(SELECTOR_NAVIGATION_CONTAINER);
    if ($navigationContainer.length > 0 && activeComponentIndex > 0) {
      // If we're in component navigation and not on the first component, go back
      handleNavigationBackButtonClick();
    } else {
      // Original behavior for other contexts
      $(SELECTOR_BACK_BUTTON).addClass('hid');
      $(`.${CHILDREN_ACTIVE_CLASS}`).removeClass(CHILDREN_ACTIVE_CLASS);
      $(`.js-ao-sticky-menu__sheet-list-${activeParentMenu}`).addClass(ACTIVE_CLASS);
    }
  };

  const initializeComponentNavigation = () => {
    const $navigationContainer = $(SELECTOR_NAVIGATION_CONTAINER);
    if ($navigationContainer.length > 0) {
      // Initialize navigation buttons
      $(SELECTOR_NEXT_BUTTON).on('click', handleNextButtonClick);
      $(SELECTOR_FINISH_BUTTON).on('click', handleNextButtonClick); // Finish button uses same handler
      $(SELECTOR_BACK_BUTTON_NAV).on('click', handleNavigationBackButtonClick);

      // Ensure first component is active on initialization
      resetComponentNavigation();
    }
  };

  this.handleMenuItemClick = (e) => {
    const $currentTarget = $(e?.currentTarget);
    $currentTarget.addClass('ao-sticky-menu__list-item--active');
    openMenu($currentTarget?.data('seo-name'));
  };

  const handleParentClick = (e) => {
    const $currentParent = $(e.currentTarget);
    const currentParentTechnicalName = $currentParent.data('technical-name');
    $currentParent.parent().removeClass(ACTIVE_CLASS);
    $currentParent
      .parent()
      .siblings('.ao-sticky-menu__sheet-children')
      .find(`.js-ao-sticky-menu__sheet-children-item-${currentParentTechnicalName}`)
      .addClass(CHILDREN_ACTIVE_CLASS);
    $(SELECTOR_BACK_BUTTON).removeClass('hid');
  };

  const handleOptionClick = () => {
    $(SELECTOR_CLICKABLE_ELEMENT).on('click', (event) => {
      const eventName = $(SELECTOR_MENU).data('event-name');
      const $currentMenuItem = $(event.currentTarget);
      const optionTitle = $currentMenuItem.data('option-title');
      const menuItemTitle = $currentMenuItem.data('menu-item-title');
      const parent = $currentMenuItem.data('parent-title');

      this.common.sendAmplitudeEvent({
        ampEventName: eventName,
        navigation_menu_option: optionTitle,
        navigation_menu_section: menuItemTitle,
        navigation_submenu_section: parent,
      });
    });
  };

  this.initiate = (e) => {
    this.handleMenuItemClick(e);
    handleOptionClick(e);

    $(SELECTOR_CLOSE_SHEET).on('click', closeMenu);
    $(SELECTOR_PARENT_ITEM).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      handleParentClick(event);
    });
    $(SELECTOR_BACK_BUTTON).on('click', handleSheetBackButtonClick);
    $(SELECTOR_OUTSIDE).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu();
    });

    // Initialize component navigation
    initializeComponentNavigation();
  };

  this.openStickyMenu = () => {
    openMenu();
  };

  this.closeStickyMenu = () => {
    closeMenu();
  };

  this.initiateWithoutOpening = () => {
    $(SELECTOR_CLOSE_SHEET).on('click', closeMenu);
    $(SELECTOR_PARENT_ITEM).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      handleParentClick(event);
    });
    $(SELECTOR_BACK_BUTTON).on('click', handleSheetBackButtonClick);
    $(SELECTOR_OUTSIDE).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu();
    });

    // Initialize component navigation
    initializeComponentNavigation();
  };

  // Public method to switch to a specific component
  this.switchToComponent = (componentIndex) => {
    if (!Number.isNaN(componentIndex)) {
      switchToComponent(componentIndex);
    }
  };
}
